import {SxProps} from '@mui/material';

export const STYLES = {
  root: {
    px: '20px',
    height: '100%',
    width: '100%',
    gap: '20px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
    flexWrap: 'wrap',
  },
  tabs: {
    width: 'fit-content',
    maxWidth: '100%',
    minHeight: 'auto',
    height: 40,
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',

    '& .MuiTab-root': {
      minHeight: 'auto',
      position: 'relative',
      height: 38,
      backgroundColor: '#FFFFFF',
      fontSize: 12,
      zIndex: 2,

      '&:first-of-type': {
        borderRadius: '8px 0px 0px 8px',
      },

      '&:last-child': {
        borderRadius: '0px 8px 8px 0px',
      },
    },

    '& .Mui-selected': {
      color: '#0D99FF',
    },

    '& .MuiTabs-indicator': {
      height: 4,
      backgroundColor: '#0D99FF',
    },
  },
} as const satisfies SxProps;
